import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import GoogleMapReact from "google-map-react";
import Map from '@material-ui/icons/Map'
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */

const PinLocation = ({text}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', fontSize: '20px'}}>
			<Map color={'error'} fontSize={'small'}/><br/>
			<span style={{fontSize: '10px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};

export default class ScheduleMapFE extends Framework.Components.Collection {
	constructor(props) {
		super(props, Types.Tickets._name);

		this.state.tickets = [];
		this.state.pins = [];

		this.state.name = this.props.name || '';

		this.state.latitude = null;
		this.state.longitude = null;
		this.state.center = null;
		this.state.defaultCenter = {
			lat: null,
			lng: null
		};

		this.state.field_engineer = this.props.field_engineer || '';
		this.state.field_engineer_error = '';

		this.state.selected_date = this.props.selected_date || '';
		this.state.selected_date_error = '';

		this.redirect = this.props.baseUrl;
	}

	

	componentDidMount() {
		this.getCurrentLocation();
		this._ismounted = true;
		this.getTickets();
	}

	componentDidUpdate(prevProps) {
		// if (prevProps.customer_address !== this.props.customer_address) {
		// 	this.convertAddress(this.props.customer_address);
		// }

		if (prevProps.customer_name !== this.props.customer_name) {
			this.setState({name: this.props.customer_name});
		}
		if (prevProps.field_engineer !== this.props.field_engineer) {
			this.setState({
				field_engineer: this.props.field_engineer,
				field_engineer_error: ''
			}, this.getTickets);
		}
	}

	getTickets = () => {
		this.model.filter = {
			field_engineer: this.state.field_engineer,
			selected_date: this.state.selected_date,
			current: this.props.id
		};

		this.read = "GET_ENGINEER_DAY"

		this.model.submit(this, this.read).then((data) => {
			this.setState({
				tickets: data.items
			});
		})
		.then(this.convertAddresses)
	};

	convertAddresses = () => {
		return;
		// this.state.tickets.map(
		// /**
		//  * @param {Tickets_Object} ticket
		//  * @param i
		//  */(ticket, i) => {
		// 	let location = ticket.customers_locations.street_1 + " " + ticket.customers_locations.city + ", " + ticket.customers_locations.state + " " + ticket.customers_locations.zip;
		// 	fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + location + '&key=' + this.googleMapsApiKey, {
		// 		"method": "GET"}).then(response => response.json())
		// 		.then(response => {
		// 			console.log(response)
		// 			let pin = {
		// 				key:{i},
		// 				lat: response.results[0].geometry.location.lat,
		// 				lng: response.results[0].geometry.location.lng,
		// 				text: ticket.fresh_ticket || '',
		// 				zoom: 12,
		// 			}
		// 			this.setState({pins: [...this.state.pins, pin]})
		// 		})
		// 		.catch(err => console.log(err));
		//
		// })
	}

	handleSelectPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		}, this.getTickets);
	};


	handleTextFieldPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		}, this.getTickets);
	};

	getCurrentLocation = () => {
		navigator.geolocation.getCurrentPosition(this.locationSuccessful, this.locationFailed)
	}

	locationSuccessful = (pos) => {
		let crd = pos.coords;
		this.state.latitude = crd.latitude;
		this.state.longitude = crd.longitude;
		this.state.defaultCenter.lat = crd.latitude;
		this.state.defaultCenter.lng = crd.longitude;
}

	locationFailed = (err) => {
		console.log(err)
		this.state.defaultCenter.lat = 37.1867970,
		this.state.defaultCenter.lng = -93.2928740
	}

	render() {
		let zoom = 12;
		let extras = {};

		let {properties} = this.model;
		let {
			loading,
			field_engineer,
			field_engineer_error,
			field_engineers,
			selected_date,
			defaultCenter,
			latitude,
			longitude,
			name,
			center,
			tickets,
		} = this.state;

		if (center) {
			extras.center = center;
		}

		return (
			<div>
				<fieldset>
					<div style={{height: '80vh', width: '100%'}}>
						<div className="row justify-content-around">
							<div className="col">
								<div className="form-group">
									<Framework.Elements.Date
										label="Selected Date"
										property={properties.selected_date}
										value={selected_date}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>

						<GoogleMapReact
							bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
							defaultCenter={defaultCenter}
							defaultZoom={zoom}
							{...extras}
						>
							<PinLocation
								key="Current Location"
								zoom={zoom}
								lat={latitude}
								lng={longitude}
								text="Current Location"
							/>

							{this.state.pins.map(
								(pin, i) => {
									return (
										<PinLocation
											key={i}
											zoom={zoom}
											lat={pin.lat}
											lng={pin.lng}
											text={pin.text}
											/>
									)

									// let location = ticket.customers_locations;
									// if (this.state.latitude === 37.1867970 && this.state.longitude === -93.2928740) {
									// 	console.log("Initial convert", this.state.latitude, this.state.longitude)
									// 	this.convertAddress(location)
									//
									// }
									// else if (this.state.latitude != 37.1867970 || this.state.longitude != -93.2928740)
									// {
									// 	console.log("Converting Addresses...")
									// }

									// if ((!location.latitude || !location.longitude) && (this.state.latitude === 37.1867970 && this.state.longitude === -93.2928740)) {
									// 	this.convertAddress(ticket, i)
									// 	console.log(this.state.latitude, this.state.longitude)
									// }
								}
							)}
						</GoogleMapReact>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
